import { PanelInfo } from '@/components/custom';
import { Button } from '@/components/ui';
import { WifiOff } from 'lucide-react';
import AppHeader from './appHeader';

const AppErrorApiServerDisconnected = () => (
	<div className='h-screen flex flex-col space-y-3'>
		<AppHeader />
		<PanelInfo
			title='Connexion au serveur impossible'
			description={`Une erreur réseau s'est produite. Veuillez vérifier votre connexion Internet ou réessayer plus tard.`}
			className='py-10 md:py-28 border-none h-auto'
			iconClassName='text-purple-600'
			icon={WifiOff}>
			<Button
				type='button'
				onClick={() => window.location.reload()}
				variant={'secondary'}>
				Réessayer
			</Button>
		</PanelInfo>
	</div>
);

export default AppErrorApiServerDisconnected;
